<template>
  <div class="" style="background-color: rgba(245,241,237,1);">
    <div class="max-w-screen-2xl w-full mx-auto px-5 lg:px-14 xl:px-20 2xl:px-12 py-12 xl:py-14 2xl:py-20 relative overflow-hidden">
      <div class="flex flex-wrap items-center">
        <div class="w-full md:w-1/2 md:pr-10 xl:pr-28 space-y-3.5 lg:space-y-5 text-center md:text-left pb-7 md:pb-0">
          <h2 class="text-3xl md:text-4xl xl:text-6xl font-ww-medium font-extrabold">{{ headlineText }}</h2>

          <a :href="buttonHref" class="whitespace-nowrap font-medium font-ww-medium md:text-2xl xl:text-3xl whitespace-nowrap inline-block space-x-3 bg-[#f1574b] text-center text-lg leading-4 text-white transition-all px-7 py-4 rounded-full">
            {{ buttonText }}
          </a>

          <p class="flex items-center justify-center md:justify-start text-gray-300 space-x-2">
            <!-- Star images remain the same -->
            <img src="//lifeboostcoffee.com/cdn/shop/t/173/assets/star_16x.png?v=92104350041965348951663902474" class="w-4" alt="first full star">
            <img src="//lifeboostcoffee.com/cdn/shop/t/173/assets/star_16x.png?v=92104350041965348951663902474" class="w-4" alt="second full star">
            <img src="//lifeboostcoffee.com/cdn/shop/t/173/assets/star_16x.png?v=92104350041965348951663902474" class="w-4" alt="third full star">
            <img src="//lifeboostcoffee.com/cdn/shop/t/173/assets/star_16x.png?v=92104350041965348951663902474" class="w-4" alt="fourth full star">
            <img src="//lifeboostcoffee.com/cdn/shop/t/173/assets/star_16x.png?v=92104350041965348951663902474" class="w-4" alt="fifth full star">
            <span class="text-black font-open-sans">{{ allReviewsCount }} {{reviewCount}}</span>
          </p>
        </div>
        <div class="w-full md:w-1/2 md:pl-10">
          <div id="" class="lazy__container  aspect-auto">
            <nuxt-img class="lock w-full h-full object-cover"
                      :src="coffeeImageSrc"
                      width="1920"
                      height="993"
                      loading="lazy"
                      format="webp"
                      sizes="xs:330px sm:440px md:600px lg:1024px xl:1600px 2xl:1920px"
                      :alt="coffeeImageAlt"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

const {data, error} = useFetch('https://lifebooxt.vercel.app/api/judgememedals')
const allReviewsCount = ref(0)

// Watch for changes in data or error
watchEffect(() => {
  if (!error.value && data.value) {
    allReviewsCount.value = data.value?.all_reviews_count || 0;
  }
});

const props = defineProps({
  headlineText: {
    type: String,
    default: 'Fuel Your Life with the Cleanest, Healthiest Coffee Possible'
  },
  buttonText: {
    type: String,
    default: 'SAVE 58% NOW'
  },
  buttonHref: {
    type: String,
    default: '#steps'
  },
  reviewCount: {
    type: String,
    default: 'Five-Star Reviews!'
  },
  coffeeImageSrc: {
    type: String,
    default: '/assets/images/img-coffee.webp'
  },
  coffeeImageAlt: {
    type: String,
    default: 'coffeeImg'
  }
});

defineBuilderComponent({
    friendlyName: "Save now",
    canHaveChildren: false,
    inputs: [
        {
            name: "headlineText",
            type: "string",
            defaultValue: "Fuel Your Life with the Cleanest, Healthiest Coffee Possible"
        },
        {
            name: "buttonText",
            type: "string",
            defaultValue: "SAVE 58% NOW"
        },
        {
            name: "buttonHref",
            type: "string",
            defaultValue: "#steps"
        },
        {
            name: "reviewCount",
            type: "string",
            defaultValue: "Five-Star Reviews!"
        },
        {
            name: "coffeeImageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "webp"
            ],
            required: true,
            defaultValue: "/assets/images/img-coffee.webp"
        },
        {
            name: "coffeeImageAlt",
            type: "string",
            defaultValue: "coffeeImg"
        }
    ]
});
</script>